module.exports = __webpack_public_path__ + "static/media/circleCheckedIcon.f40aff58.svg";